import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { HomePage } from './pages/HomePage.tsx';
import { AboutPage } from './pages/AboutPage.tsx';
import { RacePage } from './pages/RacePage.tsx';
import { RegattaerPage } from './pages/RegattaerPage.tsx';
import { RaceEntriesPage, RaceResultsPage } from './pages/RaceEntriesPage.tsx';
import { RaceContentBoundary } from './components/RaceContentBoundary.tsx';
import { InstrumentPage } from './pages/InstrumentPage.tsx';
import { HelpLocationPage } from './pages/HelpLocationPage.tsx';
import { LiveMapPage } from './pages/LiveMapPage.tsx';
import { ReplayPage } from './pages/ReplayPage.tsx';
import { CoursePreviewPage } from './pages/CoursePreviewPage.tsx';
import { MyChartPage } from './pages/MyChartPage.tsx';
import { AdminLogin } from './pages/admin/Login.tsx';
import { AdminLayout } from './pages/admin/Layout.tsx';
import { AdminDashboard } from './pages/admin/Dashboard.tsx';
import { AdminBoats } from './pages/admin/Boats.tsx';
import { AdminTrackers } from './pages/admin/Trackers.tsx';
import { AdminForeninger } from './pages/admin/Foreninger.tsx';
import { AdminRaces } from './pages/admin/Races.tsx';
import { AdminRaceDetail } from './pages/admin/RaceDetail.tsx';
import { AdminAdmins } from './pages/admin/Admins.tsx';
import { AdminClasses } from './pages/admin/Classes.tsx';
import { MyHome } from './pages/registrar/MyHome.tsx';
import { MyBoats } from './pages/registrar/MyBoats.tsx';
import { MyRaces } from './pages/registrar/MyRaces.tsx';
import { LoginPage } from './pages/konto/LoginPage.tsx';
import { RequestPage } from './pages/konto/RequestPage.tsx';
import { SetPasswordPage } from './pages/konto/SetPasswordPage.tsx';
import { ForgotPage } from './pages/konto/ForgotPage.tsx';
import { MinSide } from './pages/konto/MinSide.tsx';
import { AdminKontoer } from './pages/admin/Kontoer.tsx';
import { AdminMarker } from './pages/admin/Marker.tsx';
import { AdminBaner } from './pages/admin/Baner.tsx';

/**
 * Regatta-ruta: frisk montering per regatta (key=slug — ingen tilstand henger
 * igjen mellom to regattaer) + selvhelbredende feilgrense rundt sida.
 */
function RaceRoute() {
  const { slug } = useParams();
  return (
    <RaceContentBoundary key={slug ?? 'race'}>
      <RacePage />
    </RaceContentBoundary>
  );
}

export function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        <Routes>
          {/* Offentlige */}
          <Route path="/" element={<HomePage />} />
          <Route path="/om" element={<AboutPage />} />
          <Route path="/regattaer" element={<RegattaerPage />} />
          <Route path="/r/:slug" element={<RaceRoute />} />
          <Route path="/r/:slug/resultater" element={<RaceResultsPage />} />
          <Route path="/r/:slug/pameldte" element={<RaceEntriesPage />} />
          <Route path="/instrument" element={<InstrumentPage />} />
          <Route path="/hjelp/posisjon" element={<HelpLocationPage />} />
          <Route path="/kart/:slug" element={<LiveMapPage />} />
          <Route path="/kart/:slug/reprise" element={<ReplayPage />} />
          <Route path="/bane/:id" element={<CoursePreviewPage />} />
          <Route path="/minkart/:slug" element={<MyChartPage />} />

          {/* Personlige kontoer (seilere) */}
          <Route path="/logg-inn" element={<LoginPage />} />
          <Route path="/konto/ny" element={<RequestPage />} />
          <Route path="/konto/sett-passord" element={<SetPasswordPage />} />
          <Route path="/konto/glemt" element={<ForgotPage />} />
          <Route path="/min" element={<MinSide />} />

          {/* Admin / registrar */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="boats" element={<AdminBoats />} />
            <Route path="trackers" element={<AdminTrackers />} />
            <Route path="foreninger" element={<AdminForeninger />} />
            <Route path="races" element={<AdminRaces />} />
            <Route path="races/:id" element={<AdminRaceDetail />} />
            <Route path="admins" element={<AdminAdmins />} />
            <Route path="classes" element={<AdminClasses />} />
            <Route path="kontoer" element={<AdminKontoer />} />
            <Route path="merker" element={<AdminMarker />} />
            <Route path="baner" element={<AdminBaner />} />

            {/* Registrar selvbetjening */}
            <Route path="min-side" element={<MyHome />} />
            <Route path="min-side/baater" element={<MyBoats />} />
            <Route path="min-side/regattaer" element={<MyRaces />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}
